// extracted by mini-css-extract-plugin
export default {"container":"Ml_xth9iz8f3daHWQNSj","disabled":"nwP9cnuQ1fp9gFwRpAsx","title":"WIjMCkVa4ZcmmqTti8le","amount":"YcD05OUauKCZkXdl1a0E","description":"Me1_6coK9Sa42OMVIB7b"};